import ServiceBase from "base/baseService"
import { boolToNumber, } from "helper/formater"

export default class MarcaService extends ServiceBase {

    title = "Marca"
    pluralTitle = "Marcas"
    url = '/cadastro/produto/marca'
    frontUrl = '/cadastro/produto/marca'
    frontUrlList = '/cadastro/produto/marcalist'
    primaryKey = 'codigo_marc'

    prepareToFront(data = {}) {

        data.ativo_marc = boolToNumber(data.ativo_marc, true)

        return data
    }

    prepareToSave({ data }) {

        data.ativo_marc = boolToNumber(data.ativo_marc)

        delete data.meta

        return data

    }

}
